import axios from "axios";
import Storages from "../helper/storages";
import ErrorHandler from "./errorHandler";
import useEndpoints from "./useEndpoints";
var RefreshToken = () => {
    var endpoints = useEndpoints();
    axios.get(endpoints.refreshToken,
        {
            headers:
            {
                'x-auth-token': Storages.getUserToken()
            }
        }).then((res) => {
            
            Storages.setUserToken(res.data.result);
            console.log('Your activity has been extended')
        }).catch((e) => {
            console.log(e)
            ErrorHandler(e)
        })

}
export default RefreshToken